
import {defineComponent} from 'vue';

export default defineComponent({
  props: {
    color: {default: '#000000', type: String},
  },
})
